import type { Unlock } from "@iyk/music-domain/client"
import { useIntersectionObserver } from "@iyk/music-ui"
import * as React from "react"
import { useUnlocksAnalytics } from "./useUnlocksAnalytics.tsx"

const visibleRatio = 0.5
const minTimeOnScreenMs = 1_000

export const useTrackViewWhenSeen = (unlockId: Unlock.Id): ((node: Element | null) => void) => {
  const { trackView } = useUnlocksAnalytics()
  const { ref, isInView } = useIntersectionObserver({ threshold: visibleRatio })

  React.useEffect(() => {
    if (!isInView) return

    const timeout = window.setTimeout(() => trackView(unlockId), minTimeOnScreenMs)

    return () => window.clearTimeout(timeout)
  }, [isInView, unlockId, trackView])

  return ref
}
